<template>
    <section class="left-right-sec">
        <loading v-model:active="isLoading"
                 :loader="'bars'"
                 :height="80"
                 :width="80"
                 :background-color="'#fff'"
                 :opacity="0.8"
                 :blur="'2px'"
                 :color="'#ff51b8'"
                 :lock-scroll="true"
                 :can-cancel="false"
                 :is-full-page="true" />

        <div>
            <v-tour name="myTour" :steps="steps" :options="tourOptions" :callbacks="tourCallbacks"></v-tour>
        </div>

        <div v-if="!showIntroduction && !showContactSales && !showContactSalesComplete">
            <div v-if="showOrder" class="container" style="width:100%; height:170px;border-bottom: 1px solid lightgray; ">
                <div class="row">
                    <div class="col-xs-12">
                        
                    </div>
                </div>
            </div>
            <div v-else class="container" style="width:100%; height:120px;border-bottom: 1px solid lightgray; ">
                <div class="row">
                    <div class="col-xs-12">

                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div v-show="showContactSales">
                <div class="row">
                    <div class="col-md-8 col-md-offset-2">
                        <div style="margin-top:30px;"><img class="img-responsive" style="width: 350px;" src="../assets/informativ-powered-by-circle-horizontal-creditdriver01.png" /></div>

                        <p class="lead" style="margin-top:30px;">
                            Learn how CreditDriver gets high quality, verified leads, and moves prequalification beyond your website to increase conversions 30%.
                        </p>
                        <a href="https://informativ.com/get-a-demo/" class="btn btn-primary" style="margin-top:30px;margin-bottom:40px;">Schedule a Meeting</a>
                    </div>
                </div>
            </div>
            <div v-show="showContactSalesComplete">
                <div class="row">
                    <div class="col-md-8 col-md-offset-2">
                        <p class="lead" style="margin-top:30px; margin-bottom:100px;">Thank you for reaching out to us.  A sales representative will contact you shortly.</p>
                    </div>
                </div>
            </div>
            <div v-show="showIntroduction && !showContactSales && !showContactSalesComplete">
                <div class="row">
                    <div class="col-md-8 col-md-offset-2">
                        <div style="margin-top:30px;"><img class="img-responsive" style="width: 350px;" src="../assets/informativ-powered-by-circle-horizontal-creditdriver01.png" /></div>

                        <p class="lead" style="margin-top:20px;">Here is a quick tour of what a Lead looks like within Informativ's CreditDriver system.  This demo shows just some of the information we will put into the hands of your sales team to help sell more new and used vehicles.  After starting the tour, click along in the gray box to advance or go back.</p>
                        <button @click="startTour" class="btn btn-primary" style="margin-top:30px;margin-bottom:40px;">Start Tour</button>
                    </div>
                </div>
            </div>
            <div data-v-step="5" v-show="!showIntroduction && !showContactSales && !showContactSalesComplete">
                <div class="lr-inner">
                    <div class="lr-left">
                        <div data-v-step="1" class="white-r-border driver-admin">

                            <div data-intro="Choose an applicant from the grid." v-show="showOrder">

                                <div class="data-wrap checkmark-box-container">

                                    <div class="top-search-head">
                                        <div class="search-bar">
                                            <input v-model="searchTerms" type="text" class="form-control" placeholder="Search applicants">
                                        </div>
                                        <div class="export-bar-btn">
                                            <button @click="toggleShowArchived">
                                                Show Archived <img src="../assets/archive-icon.svg" class="img-fluid" alt="archive-icon">
                                            </button>
                                        </div>
                                    </div>

                                    <ApplicantGrid searchTerms="" assignedListItems="[]" showArchived="false" />
                                </div>

                            </div>
                            <div v-show="!showConfirmPrint && !showprintoffer && !showOrder">
                                <div class="white-r-border summary">
                                    <ul class="nav nav-tabs border-tabs" id="myTab" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <a class="nav-link active" id="fico-tab" data-toggle="tab" href="#fico" role="tab" aria-controls="fico" aria-selected="true">Prequalification</a>
                                        </li>
                                    </ul>
                                    <div class="tab-content border-tabs-content" id="myTabContent">
                                        <div class="tab-pane fade show active" id="fico" role="tabpanel" aria-labelledby="fico-tab">
                                            <div class="fico-summary" id="autoInquiriesScroll">
                                                <h4>Auto summary ({{autoTradeLines.length}})</h4>
                                                <div class="avail-cred">
                                                    <div class="listavail">
                                                        <div class="avl">
                                                            <p>Available Revolving Credit</p>
                                                            <h2>$8,925</h2>
                                                        </div>
                                                        <div class="avl" data-v-step="7">
                                                            <p>Auto Inquiries Last 30 Days</p>
                                                            <h2>2 Inquiries</h2>
                                                        </div>
                                                    </div>
                                                    <div class="listavail">
                                                        <div class="avl">
                                                            <p>Open Auto Accounts</p>
                                                            <h2>2</h2>
                                                        </div>
                                                        <div class="avl">
                                                            <p>Open Auto Accounts Balance</p>
                                                            <h2 class="treadopen-btn"></h2>
                                                        </div>
                                                    </div>
                                                    <div class="listavail">
                                                        <div class="avl">
                                                            <p>Newest Auto Account Age</p>
                                                            <h2>5 months</h2>
                                                        </div>
                                                        <div class="avl">
                                                            <p># of Auto Accounts with Derogatory Mark (24 mo)</p>
                                                            <h2>0</h2>
                                                        </div>
                                                    </div>
                                                    <div id="autoTradeLineScroll" class="listavail">
                                                        <div class="avl">
                                                            <p>Worst Rating</p>
                                                            <h2></h2>
                                                        </div>
                                                        <div class="avl">
                                                            <p></p>
                                                            <h2></h2>
                                                        </div>
                                                    </div>
                                                    <div class="listavail">
                                                        <div class="avl">
                                                            <p>(18) Open · (12) Closed</p>
                                                        </div>
                                                        <div class="avl">
                                                            <div class="opp-ic not">(0) Opportunities</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div data-v-step="8" id="interestRateScroll" v-for="(autoTradeLine, index) in autoTradeLines" :key="autoTradeLine.id" v-show="index < autoTradeLinesCountToShow" class="tredline-wrap" style="margin-bottom:20px;">
                                                    <div class="trad-left">
                                                        <h2>Auto Tradeline {{index+1}}</h2>
                                                        <a v-if="autoTradeLine.tradeLineStatus" href="#" class="treadopen-btn">Closed</a>
                                                        <a v-else href="#" class="treadopen-btn">Open</a>
                                                        <span>Opened: {{autoTradeLine.originalLoanDate}}</span>
                                                        <div data-v-step="9" class="tread-rev">
                                                            <div class="opp-ic not">Payment</div>
                                                            <h2 v-if="autoTradeLine.paymentAmount >= 0">${{autoTradeLine.paymentAmount}}</h2>
                                                            <h2 v-else class="treadopen-btn"></h2>
                                                        </div>
                                                        <div data-v-step="10" class="tread-rev">
                                                            <div class="opp-ic hot">Interest rate</div>
                                                            <h2 v-if="autoTradeLine.interestRate >= 0">{{autoTradeLine.interestRate}}</h2>
                                                            <h2 v-else class="treadopen-btn"></h2>
                                                        </div>
                                                    </div>
                                                    <div class="trad-right">
                                                        <div class="progress">
                                                            <div class="progress-bar" role="progressbar" :style="'width:' + calculateAutoTradelinePercent(autoTradeLine.loanAmount, autoTradeLine.loanAmountRemaining) + '%'" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                                                        </div>
                                                        <div data-v-step="11" class="progress-data">
                                                            <div v-if="autoTradeLine.loanAmount >= 0" class="opp-ic not">Loan: ${{autoTradeLine.loanAmount}}</div>
                                                            <div v-else class="opp-ic treadopen-btn"></div>
                                                            <div v-if="autoTradeLine.loanAmountRemaining >= 0" class="opp-ic hot">Left: ${{autoTradeLine.loanAmountRemaining}}</div>
                                                            <div v-else class="opp-ic treadopen-btn"></div>
                                                        </div>
                                                        <div class="pro-stats">
                                                            <ul>
                                                                <li>
                                                                    <div class="opp-ic not">Terms</div>
                                                                    <p v-if="autoTradeLine.loanTermMonths >= 0">{{autoTradeLine.loanTermMonths}} mo</p>
                                                                    <p v-else class="treadopen-btn"></p>
                                                                </li>
                                                                <li>
                                                                    <div class="opp-ic hot">Remaining</div>
                                                                    <p>{{autoTradeLine.loanTermRemaining}} mo</p>
                                                                </li>
                                                                <li>
                                                                    <div class="opp-ic not">Late</div>
                                                                    <p>{{autoTradeLine.latePayments}}</p>
                                                                </li>
                                                                <li>
                                                                    <div class="opp-ic not">Joint</div>
                                                                    <p>No</p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="tred-bottom">
                                                        <p>Auto Tradeline {{index+1}}</p>
                                                    </div>
                                                </div>
                                                <a class="more-tred">View 1 more</a>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade " id="credit" role="tabpanel" aria-labelledby="credit-tab">
                                            <div class="fico-summary">
                                                <h4>Account balances</h4>
                                                <div class="account-bal">
                                                    <ul>
                                                        <li>
                                                            <strong>Total balances</strong>
                                                            <strong>$297,561</strong>
                                                        </li>
                                                        <li>
                                                            <span>Revolving credit</span>
                                                            <p>$8,925</p>
                                                        </li>
                                                        <li>
                                                            <span>Mortgages</span>
                                                            <p>$287,952</p>
                                                        </li>
                                                        <li>
                                                            <span>Installment Loans</span>
                                                            <p>$684</p>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div class="pastrecords">
                                                    <ul>
                                                        <li>
                                                            <h2>$0.00</h2>
                                                            <p>Past due</p>
                                                        </li>
                                                        <li>
                                                            <h2>0</h2>
                                                            <p># Past due</p>
                                                        </li>
                                                        <li>
                                                            <h2>0</h2>
                                                            <p>Public records</p>
                                                        </li>
                                                    </ul>
                                                    <ul>
                                                        <li>
                                                            <h2>$3,154</h2>
                                                            <p>Payments /mo</p>
                                                        </li>
                                                        <li>
                                                            <h2>65 months</h2>
                                                            <p>Oldest account</p>
                                                        </li>
                                                        <li>
                                                            <h2>2</h2>
                                                            <p>Total inquiries</p>
                                                        </li>
                                                    </ul>

                                                    <ul class="col2records">
                                                        <li>
                                                            <p>Credit utilization</p>
                                                            <h2>5%</h2>
                                                        </li>
                                                        <li>
                                                            <p>Hard inquiries</p>
                                                            <h2>1</h2>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div>
                                                    <div class="progress">
                                                        <div class="progress-bar" role="progressbar" v-bind:style="'width: 90%'" aria-valuenow="0" v-bind:aria-valuemin="90" aria-valuemax="100"></div>
                                                    </div>
                                                    <div class="progress-data">
                                                        <p>Good standing <strong>10</strong></p>
                                                        <p>Potentially negative <strong>1</strong></p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- right-content -->
                    <div class="lr-right" id="consumerScore">
                        <div v-show="showOrder">
                            <div data-v-step="3" style="margin-bottom:20px;">
                                <img class="img-responsive" src="../assets/applicantdetail01.png" />
                            </div>
                        </div>
                        <div v-show="!showConfirmPrint && !showprintoffer && !showOrder" class="white-r-border profile-sec summ">
                            <div class="card-close">
                                <a href="./"><img src="../assets/close-card.svg" class="img-fluid" alt="close"></a>
                            </div>
                            <div class="user-prof">
                                <h2>Esther Pxzkk</h2>
                                <div class="buy-power">
                                    &nbsp;
                                </div>
                                <div class="info-title">
                                    <h2>Vantage Score <a href="#" alt="Click to toggle score comparison..." class="infolink" style="font-size: 20px"></a></h2>
                                </div>

                                <div data-v-step="6" class="tier">
                                    <div class="tire-denotr">
                                        <div class="tirenum">
                                            <h2>509</h2>
                                        </div>
                                        <div class="tire-rate">
                                            <div class="'quality-badge-fair'">Fair</div>
                                            <h3>Fair</h3>
                                        </div>
                                    </div>
                                    <div class="tire-badge">Tier 4</div>
                                </div>

                                <div class="tire-progress">
                                    <CreditScoreBarGraph :creditScore="573" :serviceDrive="true" />
                                </div>

                                <div id="tradeInScroll" class="info-title">
                                    <h2>Customer Information</h2>
                                </div>
                                <div class="contact-info">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <h4>Cell</h4>
                                            <a href="#">555-987-6521</a>
                                        </div>
                                        <div class="col-sm-6">
                                            <h4>Email</h4>
                                            <a href="#">buujz@email.com</a>
                                        </div>
                                        <div class="col-sm-12">
                                            <h4>Address</h4>
                                            <p>9615 Black Tern Ln, Yonkers, NY 10710</p>
                                        </div>
                                    </div>
                                </div>


                                <div class="contact-info bg-back">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <h4>Current Trade-in</h4>
                                            <p>2017 Ford F-150</p>
                                            <p style="font-style:italic;font-weight:normal;">Acquired on 11/12/2021</p>
                                        </div>
                                        <div class="col-sm-6">
                                            <h4>Interested in </h4>
                                            <p>Unknown</p>
                                        </div>
                                    </div>
                                </div>


                                <div class="info-title">
                                    <h2>Pre-Qualification Certificate</h2>
                                </div>

                                <div class="get-certf">
                                    <div class="cert-img">

                                        <div class="cert-box">
                                            <div class="inner-white">
                                                <h2>Pre-Qualification</h2>
                                                <small>This certificate is presented to:</small>
                                                <h1>BASIL UUJZDJHK</h1>
                                                <p>You have been Pre-Qualified for financing VAID ONLY AT:</p>
                                                <h3>Santa Barbara Automotive</h3>
                                                <div class="cert-barcode"><img src="../assets/barcode-img.png" alt="img" class="img-fluid" height="30"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cert-actions">
                                        <a target="_blank" href="#">Print</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <footer>
                            <CreditDriverFooter />
                        </footer>

                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import CreditScoreBarGraph from './CreditScoreBarGraph';
    import CreditDriverFooter from './CreditDriverFooter.vue';
    import ApplicantGrid from './ApplicantGrid.vue';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mask } from 'vue-the-mask';
    import 'intro.js/minified/introjs.min.css';
    import VTour from './VTour.vue'
    import { vm } from '../main.js'

    export default {
        name: "ServiceDrive",
        props: {
        },
        computed: {
        },
        data() {
            return {
                addFirstName: "",
                addLastName: "",
                addEmail: "",
                addPhoneNumber: "",
                addSSN: "",
                addDateOfBirth: "",
                addStreetAddress: "",
                addCity: "",
                addState: "",
                addZipCode: "",
                addVinNumber: "",
                contactCompanyName: "",
                contactContactName: "",
                contactPhone: "",
                contactEmail: "",
                showContactSales: false,
                showContactSalesComplete: false,
                showIntroduction: true,
                showOrder: true,
                showprintoffer: false,
                showConfirmPrint: false,
                offerPresentedConfirmed: false,
                tourCallbacks: {
                    onFinish: this.tourFinish
                },
                tourOptions: {
                    useKeyboardNavigation: false,
                    highlight: true,
                    labels: {
                        buttonSkip: 'Skip tour',
                        buttonPrevious: 'Previous',
                        buttonNext: 'Next',
                        buttonStop: 'Finish'
                    }
                },
                steps: [
                    {
                        target: '[data-v-step="1"]',
                        /*header: {
                            title: 'Place a Service Drive Order',
                        },*/
                        content: `You are notified when new leads come in.  Select the consumer.`,
                        params: {
                            placement: 'top' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = true;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                            }, 100);
                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="2"]',
                        content: 'On the grid, you can quickly identify the lead\'s source',
                        params: {
                            placement: 'top'
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = true;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;

                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="3"]',
                        content: 'Next select "View Credit Profile" to see key auto attributes of the credit report.',
                        params: {
                            placement: 'top'
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = true;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;

                            process.nextTick(() => {
                                var consumerScore = document.getElementById("consumerScore");
                                consumerScore.scrollIntoView();
                            });

                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="5"]',
                        content: 'Results are displayed for the consumer',
                        params: {
                            placement: 'top',
                            enableScrolling: false
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            process.nextTick(() => {
                                window.scrollTo(0, 0);
                            });
                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="6"]',
                        content: 'The consumer\'s score',
                        params: {
                            placement: 'top',
                            enableScrolling: false
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            process.nextTick(() => {
                                var consumerScore = document.getElementById("consumerScore");
                                consumerScore.scrollIntoView();
                            });
                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="7"]',
                        content: 'See the number of auto inquires in the last 30 days.',
                        params: {
                            placement: 'bottom'
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            process.nextTick(() => {
                                var consumerScore = document.getElementById("autoInquiriesScroll");
                                consumerScore.scrollIntoView();
                            });
                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="8"]',
                        content: 'See key auto tradeline data on ALL vehicles owned by the consumer.',
                        params: {
                            placement: 'top'
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            process.nextTick(() => {
                                var consumerScore = document.getElementById("autoTradeLineScroll");
                                consumerScore.scrollIntoView();
                            });
                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="9"]',
                        content: 'See the consumer\'s Current Monthly Payment.',
                        params: {
                            placement: 'top'
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            process.nextTick(() => {
                                var consumerScore = document.getElementById("interestRateScroll");
                                consumerScore.scrollIntoView();
                            });
                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="10"]',
                        content: 'Opportunity alerts quickly alert you to potential sales indicators, such as a high interest rate.',
                        params: {
                            placement: 'top'
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            process.nextTick(() => {
                                var consumerScore = document.getElementById("interestRateScroll");
                                consumerScore.scrollIntoView();
                            });
                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="11"]',
                        content: 'Or a low remaining balance.',
                        params: {
                            placement: 'bottom'
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            process.nextTick(() => {
                                var consumerScore = document.getElementById("interestRateScroll");
                                consumerScore.scrollIntoView();
                            });
                            resolve(true);
                        })
                    }/*,
                    {
                        target: '[data-v-step="11"]',
                        content: 'Get potential trade-in information before the consumer arrives for their service appointment.',
                        params: {
                            placement: 'top'
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            process.nextTick(() => {
                                var consumerScore = document.getElementById("tradeInScroll");
                                consumerScore.scrollIntoView();
                            });
                            resolve(true);
                        })
                    }*/
                ],
                autoTradeLinesCountToShow: 1,
                autoTradeLines: [
                     {
                         id: 1,
                         leaseOrLoan: true,
                         tradeLineStatus: false,
                         cosignor: 8,
                         originalLoanDate: "Sep 12, 2016",
                         loanAmount: 35000,
                         loanAmountRemaining: 770,
                         latePayments: 0,
                         loanTermMonths: 72,
                         paymentAmount: 644.15,
                         estimatedPayOffDate: "Sep 12, 2022",
                         loanTermRemaining: 3,
                         interestRate: 8.50
                     },
                     {
                         id: 2,
                         leaseOrLoan: true,
                         tradeLineStatus: false,
                         cosignor: 4,
                         originalLoanDate: "Jan 3, 2018",
                         loanAmount: 36000,
                         loanAmountRemaining: 4200,
                         latePayments: 0,
                         loanTermMonths: 72,
                         paymentAmount: 244.25,
                         estimatedPayOffDate: "Nov 12, 2021",
                         loanTermRemaining: 3,
                         interestRate: 6.75
                     }
                ],
            }
        },
        methods: {
            startTour() {
                this.showIntroduction = false;
                vm.$tours['myTour'].start();
            },
            tourFinish() {
                this.showContactSales = true;
            },
            submitContactInformation() {
                this.showContactSales = false;
                this.showContactSalesComplete = true;
            },
            calculateAutoTradelinePercent(loanAmount, loanAmountRemaining) {
                return ((loanAmount - loanAmountRemaining) / loanAmount) * 100;
            }
        },
        mounted() {

        },
        directives: { mask },
        components: {
            ApplicantGrid,
            CreditScoreBarGraph,
            CreditDriverFooter,
            VTour,
            Loading
        }
    }
</script>

<style type="text/css" scoped>
    @import '../css/style.css';
    @import '../css/style2.css';
    @import '../css/responsive.css';

    input[type="submit"]:disabled {
        background: #888;
        cursor: not-allowed;
    }

    .img-responsive {
        width: 100%;
        height: auto;
    }

    input[type=checkbox] {
        /* Double-sized Checkboxes */
        -ms-transform: scale(1.5); /* IE */
        -moz-transform: scale(1.5); /* FF */
        -webkit-transform: scale(1.5); /* Safari and Chrome */
        -o-transform: scale(1.5); /* Opera */
        padding: 10px;
    }
</style>